import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


export default function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={props.boxPadding === undefined ? 3 : props.boxPadding}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }